import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { UserData } from "../../../Context/DataContext";
import { RandomId } from "../../../Utils/RandomId";
import styles from "./styles/KeepAlive.module.css" ;
import { formatTime } from "../../../Utils/formatTime";
import { KeepAliveClick } from "../../../Utils/inheritance";
import { floatMessage } from "../../../Utils/floatMessage";
import { keepAliveFrequencyTimeOptions } from "../../../Utils/timeOptions";


function Frequency({value, disabled, timeContent, float_message=undefined}) {
    const one_day = 24*60*60*1000
    const userData = UserData()
    const [showOptions, setShowOptions]=useState(false)
    const [selected, setSelected] = useState()
    const time_options=keepAliveFrequencyTimeOptions
    const wrapperRef = useRef(null)
    const handledlick=(e) =>{
        console.log(e)
        setSelected(e)
        setShowOptions(false)
        const new_inheritance_parameters = KeepAliveClick(Number(e), userData.UserData.inheritance_parameters)
        userData.setUserData({...userData.UserData, "keep_alive_timeout":Number(e), "inheritance_parameters":new_inheritance_parameters, "last_login":Number(Date.now())})
        userData.setCustomerUser({...userData.CustomerUser, "self_recovery_status":'inactive'})
        userData.Update(RandomId(3))
        if (float_message) floatMessage(float_message)
    }
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
          if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowOptions(false)
          }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          // Unbind the event listener on clean up
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [wrapperRef]);

    useEffect(()=>{

        try {
            setSelected(userData.UserData.keep_alive_timeout)
        } catch (error) {
            setSelected(3600000)
        }        
    }, [userData.UserData.keep_alive_timeout])
    return (
        <div disabled={disabled} onClick={()=>setShowOptions(!showOptions)} ref={wrapperRef} className={styles.main}>
            <div className={styles.logo}/>
            <span className={styles.value}>{formatTime(selected, timeContent)}</span>
            {
                (showOptions) &&
                <div onClick={(e)=>e.stopPropagation()} className={styles.options}>
                    {time_options.map(e=>{
                        return(
                            <div key={e} onClick={()=>handledlick(e)} className={styles.option_cell}>
                                {formatTime(e, timeContent)}
                            </div>
                        )
                        })
                    }
                    
                </div>
            }
        </div>
    );
}

export default Frequency;
